<template>
  <div class="security-banner">
    <img :src="securityBanner" alt="" />
    <div class="absolute">
      <div class="title">智能安防</div>
      <div class="text">监控系统+门禁系统+智能巡更系统</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import securityBanner from "../../../../assets/programme/securityBanner.png";

export default {
  setup() {
    return reactive({
      securityBanner: securityBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.security-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .security-banner {
    min-width: 1180px;
  }
}
.security-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 90px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
